import { gql } from "../../codegen/__generated";

export const getApplicationSettings = gql(/* GraphQL */ `
  query GetApplicationSettings {
    application_settings {
      ...ApplicationSettingsDetails
    }
  }
`);
